<template>
  <div>
    <div
      v-if="showCarousel && imagesLoaded"
      class="carousel-banner"
    >
      <VueSlickCarousel
        :dots="true"
        v-bind="settings"
      >
        <div
          v-for="(image, index) in availableImages"
          :key="index"
        >
          <img
            :src="image"
            :alt="`Banner ${index + 1}`"
          />
        </div>
      </VueSlickCarousel>
    </div>

    <search-banner v-else-if="!showCarousel && imagesLoaded" />
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import SearchBanner from './SearchBanner.vue';

export default {
  name: 'CarouselBanner',
  components: {
    VueSlickCarousel,
    SearchBanner,
  },
  data() {
    return {
      showCarousel: false,
      imagesLoaded: false,
      availableImages: [],
      imageUrls: [
        'https://storageapoiob2bprd.blob.core.windows.net/carrossel-dashboard/banner-1.jpg',
        'https://storageapoiob2bprd.blob.core.windows.net/carrossel-dashboard/banner-2.jpg',
        'https://storageapoiob2bprd.blob.core.windows.net/carrossel-dashboard/banner-3.jpg',
      ],
      settings: {
        dots: true,
        dotsClass: 'slick-dots custom-dot-class',
        edgeFriction: 0.35,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
      },
    };
  },
  mounted() {
    this.checkImages();
  },
  methods: {
    async checkImages() {
      const imagePromises = this.imageUrls.map(url => this.checkImageExists(url));
      const results = await Promise.all(imagePromises);

      this.availableImages = this.imageUrls.filter((url, index) => results[index]);

      if (this.availableImages.length > 0) {
        this.showCarousel = true;
      } else {
        this.showCarousel = false;
      }

      this.imagesLoaded = true;
    },

    checkImageExists(url) {
      return new Promise(resolve => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;

        setTimeout(() => resolve(false), 3000);
      });
    },
  },
};
</script>

<style lang="scss">
.carousel-banner {
  border-radius: 8px;
  width: 100%;
  height: 180px;
  display: flex;
  position: relative;
  margin-bottom: 24px;
  overflow: hidden;

  @media (max-width: 1080px) {
    height: 138px;
  }

  .slick-slider {
    width: 100%;
    height: 100%;
  }

  .slick-slider,
  .slick-list,
  .slick-track {
    height: 100%;
  }

  .slick-slide {
    height: 180px;

    div {
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;

        @media (max-width: 1080px) {
          object-fit: contain;
          height: 138px;
        }
      }
    }
  }

  .slick-dots {
    bottom: 15px;
    z-index: 2;

    @media (max-width: 1080px) {
      bottom: 0;
    }

    li button:before {
      color: white;
      font-size: 12px;
      opacity: 0.7;
    }

    li.slick-active button:before {
      color: white;
      opacity: 1;
    }
  }
}
</style>
